module.exports = __webpack_public_path__ + "media/images/shared/ad/article_request-12337eafa390a475d9685b13126b9713.png";